import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/Hero";
import { MemberStrip } from "@/components/MemberStrip";
import { EditorialMarquee } from "@/components/Marquee";
import { FeaturedGrid } from "@/components/FeaturedGrid";
import { StealDeal } from "@/components/StealDeal";
import { UnderNinetyNine } from "@/components/UnderNinetyNine";
import { Manifesto } from "@/components/Manifesto";
import { Collections } from "@/components/Collections";
import { Footer } from "@/components/Footer";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const scroll = () => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    const t1 = setTimeout(scroll, 300);
    const t2 = setTimeout(scroll, 1200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <MemberStrip />
      <EditorialMarquee />
      <FeaturedGrid />
      <StealDeal />
      <UnderNinetyNine />
      <Manifesto />
      <Collections />
      <Footer />
    </main>
  );
}
